export default {
  SET_CATEGORY: 'setCategory',
  SET_ROL: 'setRol',
  SET_CURRENT_FILTER: 'setCurrentFilter',
  SET_FILTER: 'setFilter',
  SET_EVENTS: 'setEvents',
  SET_DELETE_EVENT: 'setDeleteEvent',
};
